/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/** Unique tabs using H6 as an anchor **/
$($('.product-single__content-text').find('h6').get().reverse()).each(function(i) {
  	
  	var tabName = $(this).text();
  	tabContent = '';
  	
  	//check if h6 has text inside
 	if ($(this).text() != '') {
      	
      	//hide h6
    	$(this).hide();
  
      	//combine content between H6 elements
        $(this).nextUntil('h6').each(function() {
            tabContent = tabContent + this.outerHTML;
          	
          	//hide content
            $(this).hide();
        });
		
      	//generate tab HTML
      	$('.js-accordion').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-accordion-info"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
        $('.js-accordion').prepend('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-accordion-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></a>');

    } else {	

      	//hide empty H6
      	$(this).hide();
    }
});

$(".footer__content .footer-nav h4").click(function(){
  	$(this).toggleClass("active");
	$(this).next("ul").slideToggle();
});


// Check the cookies

function getCookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
    }
    else
    {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
        end = dc.length;
        }
    }
    // because unescape has been deprecated, replaced with decodeURI
    //return unescape(dc.substring(begin + prefix.length, end));
    return decodeURI(dc.substring(begin + prefix.length, end));
} 

function adPopup() {
    var adCookie = "ad-popup";
    var promoDelay = $(".js-ad-pop").data("promo-delay");
    var promoLink = $("#brandlink").data("promo-link");
    var promoCookie = getCookie("promo-showed");
    var ad_Cookie = getCookie("ad-popup");
    if (promoCookie !== null) {
      if( ad_Cookie == null) {
        
       
        setTimeout(function() {
		  theme.promoPop("open");
		}, promoDelay);
        $(".popup-wrap").hide();
        $(".ad-popup-wrap").show();
        $(".drop-shadow").show();
      }
    }
   
    $(".js-ad-pop-close").click(function(e) {
	Cookies(adCookie, "1", { path: "/" });
	theme.promoPop("close");
	e.preventDefault();
    $(".ad-popup-wrap").hide();
  });
  
  $("#brandlink").click(function(e) {
	Cookies(adCookie, "1", { path: "/" });
	theme.promoPop("close");
	e.preventDefault();
    $(".ad-popup-wrap").hide();
    var storeUrl = "https://escentials-my-production.myshopify.com";
    window.location.href = storeUrl + promoLink;
  });
}
$(document).ready(function(){
  adPopup();
  
 
});